module.exports = __webpack_public_path__ + "img/profile.dafca3a4.svg";